import React from "react";
import style from './button.module.scss';

const Button = (props) => {

    if (props.loading)
        return (
            <button className={style[props.type]}>
                <div className={style.loading}>
                    <span className={style.first}></span>
                    <span className={style.secound}></span>
                    <span className={style.third}></span>
                </div>
            </button>
        )
    else
        return (
            <button className={style[props.type]} disabled={props.disabled} onClick={e => props.onclick(props.tag, e)}>
                <div className={style.content}>
                    {props.leftIcon ? <div className={style.leftSide}><p>{props.leftIcon}</p></div> :
                        <div className={style.noIconRight}></div>}
                    {props.label ? <div className={style.label}>{props.label}</div> : <div></div>}
                    {props.rightIcon ? <div className={style.rightSide}><p>{props.rightIcon}</p></div> :
                        <div className={style.noIconLeft}></div>}

                </div>
                {props.childerns}
            </button>
        )

}
export default Button

//how to use
//provide a container with maxWidth or width:"fit-content"
/* < Button 
disabled = {false}       : (default is false) enabeled or disabled button  true/false
tag = "n1"               : required tag to identify button
type = "solid"           : required type of button : solid/outline
label = "  جان"          : required label of buttton 
rightIcon = "a"   :  right icon font char
leftIcon = "b"       :  left icon font char 
 onclick = { handler } />: required returns name tag and event  */
